import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '請求・支払',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 6,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
  listed: true,
};
